import React, { Component } from 'react';

import { connect } from 'react-redux';
import { Navigate } from 'react-router-dom';
import { Col, Container, Row, Button } from 'react-bootstrap';

import Authenticated from '../../shared/Authenticated';

import AddUsers from '../../api/AddUser';
import AddUserEmployerType from '../../api/AddUserEmployerType';
import AddUserInsurerType from '../../api/AddUserInsurerType';
import BLOBList from '../../api/BLOBList';
import EmployerList from '../../api/EmployerList';
import LocationList from '../../api/LocationList';
import GetAdminConfiguration from '../../api/GetAdminConfig';
import RegistrationInfo from '../../api/RegistrationInfo';
import UserList from '../../api/UserList';
import UserListDetails from '../../api/UserListDetails';
import {
  unsetMemberSummary,
  unsetCoverageSummary,
  unsetAccumulatorSummary,
} from 'src/redux/member/memberSlice';
import MemberCoverageSummary from '../../api/MemberCoverageSummary';
import MemberSummary from '../../api/MemberSummary';
import Dependent from '../../api/Dependent';
import ClaimStatusSummary from '../../api/ClaimStatusSummary';
import ClaimsList from '../../api/ClaimsList';
import RetryAPI from '../../api/RetryAPI';
import APIEndpoints from '../../api/APIEndpoints';
import SpendingAccountSummary from '../../api/SpendingAccountSummary';
import MyProfileDetails from '../../api/myProfileDetails';
import CookiesService from '../../shared/CookiesService';
import { LogoutSuccessSVG, CoverageSVG } from '../../img/GlobalSVG';

import HttpErrorHandler from '../../errorhandling/HttpErrorHandler';
import { HttpSuccessCodes } from '../../errorhandling/HttpErrorCodes';
import AdminUserDetails from '../../api/AdminUserDetails';
import Breadcrumbs from '../../api/Breadcrumbs';
import MasterPermissions from '../../api/MasterPermissions';
import { axiosInstance } from '../../../api/axios';
import { resetBreadCrumb } from '../../../redux/admin/breadCrumbSlice';
import { logout } from '../../../redux/app/userSlice';
import { unSetKeys } from '../../../redux/app/keySlice';
import { setContentLoader, unSetLogin } from 'src/redux/app/appSlice';
import GenericButton from '../../../Components/GenericButton/GenericButton';
import { resetReportsSlice } from 'src/redux/admin/reportsSlice';
import { resetNotificationResp } from 'src/redux/app/messageAndNotificationSlice';

//TODO: Convert to functional component and re-write clean CSS
class Logout extends Component {
  constructor(props) {
    super(props);

    this.state = {
      logoutError: true,
      backtoLogin: false,
      serverError: false,
    };
  }

  async componentDidMount() {
    this.props.setContentLoader(5);
    if (this.props.bearerToken && !this.props.logoutApiConsumed) {
      this.LogoutRequest(this.props.bearerToken);

      //this.props.logoutAction();
      //this.props.unSetKeys();
    } else {
      this.setState({ logoutError: false });
    }
  }

  LogoutRequest = async () => {
    try {
      const response = await axiosInstance.delete(
        APIEndpoints.getLogoutResource(),
      );

      if (response.status === HttpSuccessCodes.HTTP_SUCCESS_CODE_200) {
        this.props.logoutAction();
        this.props.unSetKeys();
        this.props.unSetLogin();
        this.props.unsetCoverageSummary();
        this.props.unsetAccumulatorSummary();
        this.props.resetNotificationResp();

        CookiesService.remove('loginToken');
        CookiesService.clear();
        localStorage.clear();
        this.props.resetReportHandler();

        console.log('Logout Successfull', response.status);
        this.setState({ logoutError: false });
      } else {
        HttpErrorHandler.DisplayServerErrorMessage(response.status, '');

        //Handle Excpetion
        if (
          HttpErrorHandler.ProcessedException(response.status, 'Logout failed.')
        ) {
          this.setState({ serverError: true });
          this.setState({ backtoLogin: false });
          this.setState({ logoutError: true });
        }
      }
    } catch (error) {
      this.props.setContentLoader(0);

      HttpErrorHandler.DisplayServerErrorMessage(error?.response?.status, '');

      //Handle Excpetion
      if (
        HttpErrorHandler.ProcessedException(
          error.response.status,
          'Logout failed.',
        )
      ) {
        this.setState({ logoutError: true });
        this.setState({ serverError: true });
        this.setState({ backtoLogin: false });
      }
    }
  };

  backtoLogin = () => {
    AddUsers.resetAddUers();
    AddUserEmployerType.resetAddUersInsurer();
    AddUserInsurerType.resetAddUersInsurer();
    BLOBList.resetBLOBList();
    EmployerList.resetEmployerList();
    GetAdminConfiguration.resetAdminConfigurationResp();
    LocationList.resetLocationList();
    RegistrationInfo.resetRegistrationInfo();
    UserList.resetUserList();
    UserListDetails.resetUserListDetails();

    MemberSummary.resetMemberSummary();
    MemberCoverageSummary.resetMemberCoverageSummary();
    Dependent.resetDependent();
    ClaimStatusSummary.resetClaimStatusSummary();
    RetryAPI.resetRetryAPI();
    ClaimsList.resetClaimsList();
    SpendingAccountSummary.resetSpendingSummary();
    MyProfileDetails.resetMyProfileDetails();
    CookiesService.clear();
    APIEndpoints.resetDomainResources();
    AdminUserDetails.resetUserListDetails();
    Breadcrumbs.resetUserListDetails();
    this.props.resetBreadCrumb();
    MasterPermissions.resetPermissionFramework();

    if (!Authenticated.isAuthenticated()) {
      this.setState({
        backtoLogin: true,
      });
    }
  };

  render() {
    const { backtoLogin, serverError, logoutError } = this.state;

    if (serverError)
      return <Navigate to="/admin/server-error" push={true}></Navigate>;

    if (backtoLogin) return <Navigate to="/admin" push={true}></Navigate>;

    const element =
      !serverError && !logoutError ? (
        <Container className="mtop30 logout mx-0 px-0 m-auto">
          <div className="roller"></div>

          <Row className="h-100">
            <Col className="my-auto">
              <div id="tick-img">
                <LogoutSuccessSVG.LogoutSuccessSVG />
              </div>

              <Row className="w-50 mx-auto ">
                <Col>
                  <h1>You have been successfully logged out.</h1>

                  <p>
                    Thank you for using Administrator Portal. Your secure
                    session is now closed. We recommend you to close the browser
                    for your security.
                  </p>

                  <GenericButton
                    variant="primary"
                    className="login-button d-flex mx-auto text-center "
                    onClick={this.backtoLogin}
                  >
                    LOGIN
                  </GenericButton>
                </Col>
              </Row>

              <Row className="w-50 mx-auto ">
                <Col className="didyouknow mb-0">
                  <CoverageSVG.BulbSVG />

                  <h2>Did you know?</h2>

                  <p>
                    {' '}
                    If you are physically tired, the best thing to do is
                    exercise as it will give you more energy than sitting.
                  </p>
                </Col>
              </Row>
            </Col>
          </Row>
        </Container>
      ) : null;

    return element;
  }
}

const mapStateToProps = (state) => {
  const { blockOfBusiness, location, employer } = state.breadCrumb;

  return {
    location,
    employer,
    blockOfBusiness,
    isLoggedIn: state.user.isLoggedIn,
    bearerToken: state.user.bearerToken,
    logoutApiConsumed: state.user.logoutApiConsumed,
  };
};

const mapDispatchToProps = (dispatch) => ({
  unSetKeys: () => dispatch(unSetKeys()),
  unSetLogin: () => dispatch(unSetLogin()),
  logoutAction: () => dispatch(logout()),
  resetBreadCrumb: () => dispatch(resetBreadCrumb()),
  setContentLoader: (num) => dispatch(setContentLoader(num)),
  unsetCoverageSummary: () => dispatch(unsetCoverageSummary()),
  unsetAccumulatorSummary: () => dispatch(unsetAccumulatorSummary()),
  resetReportHandler: () => dispatch(resetReportsSlice()),
  resetNotificationResp: () => dispatch(resetNotificationResp()),
});

export default connect(mapStateToProps, mapDispatchToProps)(Logout);
